<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="省区"
                  prop="provinceId"
                >
                  <el-select
                    v-model="dialogAddEditViewForm.provinceId"
                    :disabled="eventType==='view'"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="changeProvinceFun"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item
                  label="城市"
                  prop="cityNames"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.cityNames"
                    maxlength="1024"
                    disabled
                  >
                    <el-button
                      v-if="eventType!=='view'"
                      slot="append"
                      icon="el-icon-search"
                      @click="showAreaListFun()"
                    />
                    <el-button
                      v-if="eventType!=='view'"
                      slot="append"
                      icon="el-icon-delete"
                      @click="clearAreaFun()"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="开始日期"
                  prop="startDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.startDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="结束日期"
                  prop="endDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.endDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="重点信息绩效基础户数"
                  prop="limitCount"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.limitCount"
                    :min="0"
                    :max="1000"
                    style="width:100%"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="重点绩效单户金额"
                  prop="mainAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.mainAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'mainAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'mainAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="潜力绩效单户金额"
                  prop="potentialAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.potentialAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'potentialAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'potentialAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="信息绩效单户金额"
                  prop="infoAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.infoAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'infoAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'infoAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="优秀陈列单户金额"
                  prop="goodDisplayAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.goodDisplayAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'goodDisplayAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'goodDisplayAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="活动包月金额"
                  prop="monthActivityAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.monthActivityAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'monthActivityAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'monthActivityAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="无展陈半天场金额(固定)"
                  prop="noDisplayActivityFieldAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.noDisplayActivityFieldAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'noDisplayActivityFieldAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'noDisplayActivityFieldAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="有展陈半天场金额(固定)大于等于0.25小于0.5"
                  prop="displayLessZeroTwoFiveActivityFieldAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.displayLessZeroTwoFiveActivityFieldAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'displayLessZeroTwoFiveActivityFieldAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'displayLessZeroTwoFiveActivityFieldAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="有展陈半天场金额(固定)大于等于0.5小于1"
                  prop="displayLessOneActivityFieldAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.displayLessOneActivityFieldAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'displayLessOneActivityFieldAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'displayLessOneActivityFieldAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="有展陈半天场金额(固定)大于等于1"
                  prop="displayActivityFieldAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.displayActivityFieldAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'displayActivityFieldAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'displayActivityFieldAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="无展陈半天场金额(临时)"
                  prop="provisionalNoDisplayActivityFieldAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.provisionalNoDisplayActivityFieldAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'provisionalNoDisplayActivityFieldAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'provisionalNoDisplayActivityFieldAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="有展陈半天场金额(临时)"
                  prop="provisionalDisplayActivityFieldAmount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.provisionalDisplayActivityFieldAmount"
                    :disabled="eventType==='view'"
                    @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'provisionalDisplayActivityFieldAmount')}"
                    @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'provisionalDisplayActivityFieldAmount', 0);"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 区域列表 -->
    <area-list-dialog
      :dialog-visible.sync="dialogAreaVisible"
      :province-id="selectProvinceId"
      dialog-title="城市信息"
      @selectedAreaFun="selectedAreaFun"
    />
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 选择区域
import areaListDialog from './areaListDialog'
// API
import { listAreaApi } from '@/api/v2/area';
import { viewSalaryPerformanceBaseInfoApi, saveSalaryPerformanceBaseInfoApi } from '@/api/v2/salaryPerformanceBaseInfo'

export default {
  components: {areaListDialog},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityNames: [{ required: true, message: '请选择城市', trigger: 'blur' }],
        startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
        limitCount: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        mainAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        potentialAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        infoAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        goodDisplayAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        noDisplayActivityFieldAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        displayActivityFieldAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        displayLessZeroTwoFiveActivityFieldAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        displayLessOneActivityFieldAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        provisionalNoDisplayActivityFieldAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        provisionalDisplayActivityFieldAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        monthActivityAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      dialogAreaVisible: false,
      selectProvinceId: 0
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.provinceOptions = []

        _this.dialogAddEditViewForm = {
          provinceId: '',
          provinceName: '',
          cityNames: '',
          cityIds: '',
          startDate: '',
          endDate: '',
          limitCount: 0,
          mainAmount: 0,
          potentialAmount: 0,
          infoAmount: 0,
          goodDisplayAmount: 0,
          noDisplayActivityFieldAmount: 0,
          displayActivityFieldAmount: 0,
          displayLessZeroTwoFiveActivityFieldAmount: 0,
          displayLessOneActivityFieldAmount: 0,
          provisionalNoDisplayActivityFieldAmount: 0,
          provisionalDisplayActivityFieldAmount: 0,
          monthActivityAmount: 0,
          remark: ''
        }
        _this.loadProvinceData()
        if (_this.eventType !== 'add') {
          _this.loadSalaryPerformanceBaseInfoData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadSalaryPerformanceBaseInfoData () {
      let _this = this
      viewSalaryPerformanceBaseInfoApi({ id: _this.dataId }).then(res => {
        const { data } = res
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id
      })
    },
    // 初始省区下拉数据
    loadProvinceData () {
      listAreaApi({ parentId: 1, isUserArea: 0 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.provinceOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      _this.dialogAddEditViewForm.cityNames = ''
      _this.dialogAddEditViewForm.cityIds = ''
    },
    // 显示城市列表
    showAreaListFun() {
      if(!this.dialogAddEditViewForm.provinceId){
        this.$message({ message: '请选择省区', type: 'warning' })
        return false
      }
      this.selectProvinceId = this.dialogAddEditViewForm.provinceId
      this.dialogAreaVisible = true
    },
    // 选择城市
    selectedAreaFun(selectData) {
      let cityNames = ''
      let cityIds = ''
      let currentCityIdArr = this.dialogAddEditViewForm.cityIds ? this.dialogAddEditViewForm.cityIds.split(',') : []
      let isHas = false
      selectData.forEach(item => {
        isHas = false
        currentCityIdArr.forEach(currentId => {
          if (Number(currentId) === Number(item.id)) {
            isHas = true
          }
        })
        if (!isHas) {
          cityNames += ',' + item.name
          cityIds += ',' + item.id
        }
      })
      if (cityNames.length > 0) {
        if (currentCityIdArr.length === 0) {
          cityNames = cityNames.substring(1)
          cityIds = cityIds.substring(1)
          this.dialogAddEditViewForm.cityNames = cityNames
          this.dialogAddEditViewForm.cityIds = cityIds
        } else {
          this.dialogAddEditViewForm.cityNames += cityNames
          this.dialogAddEditViewForm.cityIds += cityIds
        }
      }
    },
    // 清除城市
    clearAreaFun() {
      this.dialogAddEditViewForm.cityNames = ''
      this.dialogAddEditViewForm.cityIds = ''
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '工资绩效基础信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {

            saveSalaryPerformanceBaseInfoApi(_this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
